module.exports = __webpack_public_path__ + "static/media/merge_icon.2eb67074.svg";